import React from "react";
import ReactDOM from "react-dom";

import HexModal from "../../../app/components/modals/HexModal";
import MealsModal from "../../../app/components/modals/benefits/MealsModal";
import { translate } from "../../../infrastructure/translate/localization";

import { showErrorMessage } from "../../commons/show-error-message";
import { findCompanyLimit } from "../../../infrastructure/repository/company-repository";

function renderMealsConfigModal({ benefitSelected, country, mealExemptLimit }) {
  ReactDOM.render(
    <HexModal>
      <MealsModal
        benefit={benefitSelected}
        country={country}
        mealExemptLimit={mealExemptLimit}
      />
    </HexModal>,
    document.getElementById("modal-container")
  );
}

export async function displayMealsConfigModal({
  companyId,
  benefitSelected,
  country,
}) {
  try {
    const mealExemptLimit = await findCompanyLimit({
      companyId,
      category: "meal-benefit",
      type: "max-exempt",
      period: "day",
    });
    renderMealsConfigModal({
      benefitSelected,
      country,
      mealExemptLimit,
    });
  } catch (e) {
    showErrorMessage(translate("common-messages.basic-error-message"));
  }
}
